import { Action } from "redux";

import {
  GET_INSURANCES,
  GET_INSURANCE_BY_ID,
  SET_INSURANCE_TO_NULL,
} from "./types";

interface InsuranceAction extends Action {
  payload: any;
}

const initialState = {
  insurances: [],
  insuranceToEdit: null,
};

export default (state = initialState, action: InsuranceAction) => {
  switch (action.type) {
    case GET_INSURANCES:
      return {
        ...state,
        insurances: action.payload,
      };
    case GET_INSURANCE_BY_ID:
      return {
        ...state,
        insuranceToEdit: action.payload,
      };
    case SET_INSURANCE_TO_NULL:
      return {
        ...state,
        insuranceToEdit: null,
      };
    default:
      return state;
  }
};
